module.exports = __webpack_public_path__ + "media/icons/chevron-up-alt-6f0f2b73.png";